<template>
  <div class="shareContainer">
    <!-- 店长有我的代买和我的关注 -->
    <div style="position: sticky;top:0;width: 100%;background: #f8f8f8;"
         v-if="userInfo.userType == 'owner'">
      <van-tabs v-model="active"
                animated
                @change="onChange(active)">
        <van-tab v-for="index in shareList"
                 :key="index.name"
                 :title="index.title"></van-tab>
      </van-tabs>
    </div>
    <div :class="userInfo.userType == 'owner' ?'marginTop':'fixedTop'"
         v-if="active ==1">
      <div class="headerCode">
        <div class="headerFlexCode">
          总关注：{{totalSubs}}
        </div>
        <div class="headerFlexCode">
          今日关注：{{todaySubs}}
        </div>
      </div>
    </div>

    <div v-if="orderList.length !== 0"
         :class="userInfo.userType == 'owner'&&active == 1 ?'MTop':'listTop'">

      <!-- 分页 -->
      <van-list v-model="loading"
                :finished="finished"
                finished-text="没有更多了~"
                @load="onLoad"
                :immediate-check="false"
                :class="AgentIsShow == true ? 'cardList' : ''">
        <div v-for="item in orderList"
             :key="item.id">
          <!-- 关注 -->
          <div class="shareList"
               v-if="active == 1">
            <div class="everylist flex">
              <!-- <div class="shareAvatar"
                   v-if="item.avatarUrl">
                <img :src="item.avatarUrl"
                     alt=""
                     style="border-radius: 50%;width: 12.8vw;" />
              </div>
              <div class="shareAvatar"
                   v-else>
                <img class="avatar"
                     src="../../../assets/images/default.jpeg"
                     alt=""
                     style="border-radius: 50%;width: 12.8vw;" />
              </div> -->
              <div style="width: 100%;">
                <div class="between betweenBottom">
                  <div class="flex">
                    <div class="nickName">新增关注人</div>
                  </div>
                  <div class="timer">
                    {{ item.subDate }}
                  </div>
                </div>
                <!-- <div class="between">
                  <div class="flex">
                    <svg class="iconSize"
                         aria-hidden="true">
                      <use xlink:href="#icon-shoujitubiao"></use>
                    </svg>
                    <div class="leftList"> {{ item.phoneNumber }}</div>
                  </div>
                  <div class="updateColor">查看详情</div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="angeList"
               v-if="active == 0">
            <div class="alist flex"
                 @click="onDetail(item)">
              <div style="width: 100%;">
                <div class="between">
                  <div>
                    <div class="flex  betweenBottom">
                      <svg class="iconSize"
                           aria-hidden="true">
                        <use xlink:href="#icon-weixinnichengtubiao"></use>
                      </svg>
                      <div class="nickAngentName">{{ item.name }}</div>
                    </div>
                    <div class="flex angeNumber">
                      <svg class="iconSize"
                           aria-hidden="true">
                        <use xlink:href="#icon-daimaishangpinshutubiao"></use>
                      </svg>
                      <div class="leftList"> 代买商品数：{{ item.goodsQuantity }}</div>
                    </div>
                  </div>
                  <div class="updateColor">查看详情</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
    <!-- 空页面 -->
    <div class="noShares"
         v-if="orderList.length == 0">
      <div class="nullPage">
        <img src="../../../assets/images/update.png"
             alt />
      </div>
      <div v-if="!firstLoading&&this.userInfo.userType == 'owner'">
        <div class="noShareText">暂无代买</div>
        <button class="share_button _button"
                @click="onClickAgent()">
          立即代买
        </button>
      </div>
      <div v-else>
        <div class="noShareText">暂无关注</div>
      </div>
    </div>
    <van-popup v-model="IsDetailShow"
               class="popupBorder">
      <DetailPop v-if="IsDetailShow"
                 :msg="msg"></DetailPop>
      <div class="DetailPopTitle"
           v-if="IsDetailtitleShow">
        <div class="orderDetailPosition">{{ orderGoodsDetail }}</div>
        <van-icon name="cross"
                  @click="onDetailClose"
                  color="#999"
                  size="18px"
                  style="position: absolute;z-index: 10;top: 16px;right: 16px;" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  Tab,
  Tabs,
  Toast,
  Dialog,
  List,
  Loading,
  Overlay,
  Popup,
  Icon,
  Picker
} from "vant";
import loading from "../../components/loading/loading";
import { mapGetters } from "vuex";
import DetailPop from "../../components/myStatisticsDetail/index";
import service from "../../api/myShare/index";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [List.name]: List,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    loading,
    DetailPop
  },
  data () {
    return {
      orderGoodsDetail: '下单商品详情',
      msg: {},   //传值
      msgName: '',   //传值
      IsDetailShow: false, //详情弹窗显示隐藏
      IsDetailPopShow: false, //下单商品详情弹窗显示隐藏
      IsDetailtitleShow: false, //下单商品详情标题显示隐藏
      firstLoading: false,
      isLoading: true, //loading状态
      active: 0,
      activeType: 0,
      shareList: [
        { name: 0, title: "我的代买" },
        { name: 1, title: "我的关注" }
      ],
      orderList: [],
      detailPage: 1, //详情分页
      page: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      totalSubs: 0, //我的关注总
      todaySubs: 0, //我的关注今日
    };
  },
  computed: {
    ...mapGetters(["userInfo", "agentShow"]),
    AgentIsShow () {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },

  },
  mounted () {
    this.IsDetailtitleShow = false
    this.init();
  },
  methods: {
    // 显示我的分享详情弹窗
    onClickDetail (item) {
      // 判断类型this.activeType显示不同title            
      this.msg = item.userId
      this.msg = { userId: item.userId, type: 2 }
      service
        .detail(this.msg.userId, this.detailPage, this.pageSize)
        .then((res) => {
          if (res.statusCode == 200) {
            if (res.data.items.length == 0) {
              this.IsDetailShow = false
              this.IsDetailPopShow = false
              Toast('无下单商品')
            } else {
              // 显示不同title 
              this.orderGoodsDetail = '下单商品详情'
              // 传值给详情页
              this.IsDetailShow = true
              this.IsDetailPopShow = true
              setTimeout(() => {
                this.IsDetailtitleShow = true
              }, 600);
            }
          } else {
            this.IsDetailShow = false
            this.IsDetailPopShow = false
            Toast(res.errors)
          }
        })
        .catch((error) => {
          this.IsDetailShow = false
          this.IsDetailPopShow = false
          // Toast(error)
        });

    },
    // 显示代买详情弹窗
    onDetail (item) {
      // 判断类型this.activeType显示不同title 
      this.msg = { name: item.name, type: 1 }
      console.log(this.msg, 213)
      service
        .agentDetail(this.msg.name, this.detailPage, this.pageSize)
        .then((res) => {
          if (res.statusCode == 200) {
            console.log(res.data.items, '代买')
            if (res.data.items.length == 0) {
              this.IsDetailShow = false
              this.IsDetailPopShow = false
              Toast('无代买商品')
            } else {
              this.orderGoodsDetail = '代买商品详情'
              // 传值给详情页
              this.IsDetailShow = true
              this.IsDetailPopShow = true
              setTimeout(() => {
                this.IsDetailtitleShow = true
              }, 600);
              console.log(item, 287)
            }
          } else {
            this.IsDetailShow = false
            this.IsDetailPopShow = false
            Toast(res.errors)
          }
        })
        .catch((error) => {
          this.IsDetailShow = false
          // Toast(error)
        });
    },
    // 关闭详情
    onDetailClose () {
      this.IsDetailShow = false
    },
    // 分享
    onClickShare () {
      this.$router.push('shareCode')
    },
    // 分享
    onClickAgent () {
      this.$router.push('AgentNickName')
    },
    // 切换
    onChange (active) {
      console.log(active, 308)
      this.isLoading = true;
      this.orderList = [];
      this.page = 1;
      this.firstLoading = true;
      this.loading = true;
      if (this.userInfo.userType == 'owner') {
        // 我的代买
        if (this.active == 0) {
          this.activeType = 0
          this.getStatisticsList()
            .then((orderList) => {
              setTimeout(() => {
                this.isLoading = false;
              }, 500);
              this.orderList = orderList.items;
              this.firstLoading = false;
              this.loading = false;
              this.finished = false;
              if (orderList.totalCount <= this.orderList.length) {
                this.finished = true;
              }
            })
            .catch((err) => {
              this.isLoading = false;
            });
        }
        // 我的关注
        if (this.active == 1) {
          this.activeType = 1
          this.active = 1
          this.getList()
            .then((orderList) => {
              setTimeout(() => {
                this.isLoading = false;
              }, 500);
              this.orderList = []
              if (orderList.subscriptionList) {
                if (orderList.subscriptionList.items.length > 0) {
                  this.orderList = orderList.subscriptionList.items;
                }
              }
              this.firstLoading = true;
              this.loading = false;
              this.finished = false;
              this.totalSubs = orderList.totalSubs
              this.todaySubs = orderList.todaySubs
              if (orderList.subscriptionList.totalCount <= this.orderList.length) {
                this.finished = true;
              }
            })
            .catch((err) => {
              this.isLoading = false;
            });
        }
      }
      if (this.userInfo.userType == 'employee') {
        this.activeType = 1
        this.active = 1
        this.getList()
          .then((orderList) => {
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
            this.orderList = []
            if (orderList.subscriptionList) {
              if (orderList.subscriptionList.items.length > 0) {
                this.orderList = orderList.subscriptionList.items;
              }
            }
            this.firstLoading = true;
            this.loading = false;
            this.finished = false;
            this.totalSubs = orderList.totalSubs
            this.todaySubs = orderList.todaySubs
            if (orderList.subscriptionList.totalCount <= this.orderList.length) {
              this.finished = true;
            }
          })
          .catch((err) => {
            this.isLoading = false;
          });
      }
    },
    // 获取列表
    init () {
      this.activeType = 1
      this.page = 1;
      this.firstLoading = true;
      this.loading = false;
      // 店长
      if (this.userInfo.userType == 'owner') {
        if (this.active == 0) {
          this.activeType = 0
          this.getStatisticsList()
            .then((orderList) => {
              setTimeout(() => {
                this.isLoading = false;
              }, 500);
              this.orderList = orderList.items;
              this.finished = false;
              this.firstLoading = false;
              if (orderList.totalCount <= this.orderList.length) {
                this.finished = true;
                this.loading = false;
              }
            })
            .catch((err) => {
              this.isLoading = false;
            });
        }
        // 我的关注
        if (this.active == 1) {
          this.activeType = 1
          this.active = 1
          this.getList()
            .then((orderList) => {
              setTimeout(() => {
                this.isLoading = false;
              }, 500);
              this.orderList = [];
              if (orderList.subscriptionList) {
                if (orderList.subscriptionList.items.length > 0) {
                  this.orderList = orderList.subscriptionList.items;
                }
              }
              this.finished = false;
              this.firstLoading = true;
              this.totalSubs = orderList.totalSubs
              this.todaySubs = orderList.todaySubs
              if (orderList.subscriptionList.totalCount <= this.orderList.length) {
                this.finished = true;
                this.loading = false;
              }
            })
            .catch((err) => {
              this.isLoading = false;
            });
        }
      }
      if (this.userInfo.userType == 'employee') {
        this.activeType = 1
        this.active = 1
        this.getList()
          .then((orderList) => {
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
            this.orderList = [];
            if (orderList.subscriptionList) {
              if (orderList.subscriptionList.items.length > 0) {
                this.orderList = orderList.subscriptionList.items;
              }
            }

            this.finished = false;
            this.firstLoading = true;
            this.totalSubs = orderList.totalSubs
            this.todaySubs = orderList.todaySubs
            if (orderList.subscriptionList.totalCount <= this.orderList.length) {
              this.finished = true;
              this.loading = false;
            }
          })
          .catch((err) => {
            this.isLoading = false;
          });

      }

    },
    // 关注
    getList () {
      return new Promise((resolve, reject) => {
        var month = 0
        if (this.activeType == 1) {
          month = 0
        }
        console.log(this.activeType, 388)
        service
          .followPageList(this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            // reject();
          });
      });
    },
    // 代买
    getStatisticsList () {
      return new Promise((resolve, reject) => {
        service
          .statisticsList(this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            // reject();
          });
      });
    },
    onLoad () {
      this.page++;
      if (this.userInfo.userType == 'owner') {

        if (this.active == 0) {
          this.getStatisticsList().then((orderList) => {
            this.isLoading = false;
            this.orderList = this.orderList.concat(orderList.items);
            this.loading = false;
            this.finished = false;
            if (orderList.totalCount <= this.orderList.length) {
              this.finished = true;
            }
          });
        }
        if (this.active == 1) {
          this.getList().then((orderList) => {
            this.isLoading = false;
            this.orderList = this.orderList.concat(orderList.subscriptionList.items);
            this.loading = false;
            this.finished = false;
            this.totalSubs = orderList.totalSubs
            this.todaySubs = orderList.todaySubs
            if (orderList.subscriptionList.totalCount <= this.orderList.length) {
              this.finished = true;
            }
          });
        }
      }
      if (this.userInfo.userType == 'employee') {
        this.active = 1
        this.getList().then((orderList) => {
          this.isLoading = false;
          this.orderList = this.orderList.concat(orderList.subscriptionList.items);
          this.loading = false;
          this.finished = false;
          this.totalSubs = orderList.totalSubs
          this.todaySubs = orderList.todaySubs
          if (orderList.subscriptionList.totalCount <= this.orderList.length) {
            this.finished = true;
          }
        });
      }

    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~'>>>';

.shareContainer {
  width: 100%;
  overflow-y: scroll;
  //
  position: fixed;
  height: 100%;
  background: #f8f8f8;
  // font-size: 14px;
  .headerCode {
    display: flex;
    height: 46px;
    line-height: 46px;
    padding: 0 24px;
  }
  .headerFlexCode {
    flex: 1;
  }
  @{deep}.van-tab__text--ellipsis {
    color: #999;
  }

  // 折叠版样式
  @{deep}.van-collapse-item__wrapper {
    position: absolute;
    width: 100%;
    z-index: 1;
  }

  @{deep} .van-cell {
    border-radius: 8px;
    border: 1px solid #e6e6e6;
    padding: 1.87vw 4.26667vw;
  }

  .scroll {
    margin-top: 64px;
  }

  .scrollAgent {
    margin-top: 64px;
    margin-bottom: 48px;
  }

  .DetailPopTitle {
    background: #fff;
    height: 50px;
    // line-height: 50px;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .monthItem {
    width: 70px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e6e6e6;
    padding: 0 14px 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .noShares {
    width: 100%;
    text-align: center;
    font-size: 3.2vw;
    color: #92909a;
    padding-top: 208px;
  }

  .noShareText {
    padding-top: 24px;
  }

  .orderDetailPosition {
    position: absolute;
    z-index: 10;
    top: 16px;
    left: 50%;
    width: 100px;
    margin-left: -50px;
    font-size: 16px;
    font-weight: 600;
  }

  .month {
    border-bottom: 1px solid #ebedf0;
    height: 80px;
    overflow: auto;
  }
  .nickAngentName {
    margin-left: 6px;
  }
  // .nickName {
  //   width: 85px;
  // }
  .timer {
    font-size: 12px;
    color: #999999;
  }
  .leftList {
    margin-left: 6px;
  }

  // 分享头像
  .shareAvatar {
    width: 48px;
    height: 48px;
  }

  .between {
    // margin-left: 16px;
    margin-right: 16px;
  }

  .everylist {
    .between {
      // margin-left: 12px;
      margin-right: 0;
    }
  }
  .alist {
    height: 78px;
    .between {
      // margin-left: 12px;
      margin-right: 0;
    }
  }
  .angeNumber {
    padding-top: 8px;
  }
  // .betweenBottom {
  //   margin-bottom: 8px;
  // }

  .shareList {
    margin: 0 12px 8px;
    padding: 0 12px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 4px 8px 1px #ebebeb;
    border: 0.5px solid #e6e6e6;
    height: 46px;
    line-height: 46px;
  }
  .angeList {
    margin: 0 12px 8px;
    padding: 0 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 4px 8px 1px #ebebeb;
    border: 0.5px solid #e6e6e6;
  }

  @{deep}.van-tab--active .van-tab__text--ellipsis {
    color: #f00724;
    font-weight: 600;
  }

  .share_button {
    width: 80px;
    height: 32px;
    background: #f00724;
    border-radius: 4px 4px 4px 4px;
    color: #fff;
    border: 0;
    margin-top: 24px;
  }

  @{deep} .van-tabs__nav .van-tabs__line {
    height: 2px;
  }

  @{deep}.van-tabs--line .van-tabs__wrap {
    height: 48px;
    //   padding: 2vw 0;
    background: #fff;
  }
  .marginTop {
    position: sticky;
    top: 48px;
    width: 100%;
    background: #f8f8f8;
  }
  .fixedTop {
    position: sticky;
    top: 0px;
    width: 100%;
    background: #f8f8f8;
  }
  // .MTop {
  // margin-top: 12px;
  // }
  .listTop {
    margin-top: 12px;
  }
  // 如果有代买
  .cardList {
    margin-bottom: 50px;
  }
}
</style>